import React, { useEffect } from 'react';
import './App.css';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Testimonials from './components/Testimonials';
import CertificateProductsHistory from './components/CertificateProductsHistory';
import About from './components/About';
import Services from './components/Services';
import ScrollReveal from 'scrollreveal';

function App() {
  useEffect(() => {
    const sr = ScrollReveal({
      origin: 'bottom',
      distance: '20px',
      duration: 200,
      easing: 'ease-in-out', 
      opacity: 0, 
      reset: true,
    });

    sr.reveal('#about', { delay: 200 });
    sr.reveal('#services', { delay: 200 });
    sr.reveal('#certificate-products-history', { delay: 200 });
    sr.reveal('#testimonials', { delay: 200 });
  }, []);

  return (
    <div className="App">
      <Navbar />
      <Hero/>
      <div id="about">
        <About />
      </div>
      <div id="services">
        <Services />
      </div>
      <div id="certificate-products-history">
        <CertificateProductsHistory />
      </div>
      <div id="testimonials">
        <Testimonials />
      </div>
      <Footer />
    </div>
  );
}

export default App;